<my-table
  #table
  key="RunnerRegistrationTokenListComponent"
  [defaultColumns]="columns"
  i18n-paginatorText
  paginatorText="tokens per page"
  [dataLoader]="dataLoader"
  columnConfig="false"
>
  <ng-template #totalTitle let-totalRecords>
    <ng-container i18n>{ totalRecords, plural, =0 {No token} =1 {1 token} other {{{ totalRecords | myNumberFormatter }} tokens}}</ng-container>
  </ng-template>

  <ng-template #captionRight>
            <my-button theme="primary" i18n-label label="Generate token" icon="add" (click)="generateToken()"></my-button>

  </ng-template>

  <ng-template #tableCells let-registrationToken>
    <td>
      {{ registrationToken.registrationToken }}

      <my-copy-button
        [value]="registrationToken.registrationToken" i18n-notification notification="Registration token copied"
        i18n-title title="Copy registration token"
      ></my-copy-button>
    </td>

    <td>{{ registrationToken.createdAt | ptDate: 'short'  }}</td>

    <td>{{ registrationToken.registeredRunnersCount }}</td>
  </ng-template>

  <ng-template #actionCell let-registrationToken>
    <my-action-dropdown
      placement="bottom-right top-right left auto" container="body"
      i18n-label label="Actions" [actions]="actions" [entry]="registrationToken"
    ></my-action-dropdown>
  </ng-template>

  <ng-template #noResults>
    <ng-container i18n>No registration token found for remote runners.</ng-container>
  </ng-template>
</my-table>
